import { Spin } from "antd";
import moment from "moment";
import { MdDelete } from "react-icons/md";
import { NavLink } from "react-router-dom";
import { useEffect, useState } from "react";
import { IoIosWarning } from "react-icons/io";
import ReactS3Client from "react-aws-s3-typescript";
import { FileUploader } from "react-drag-drop-files";
import { useForm, SubmitHandler } from "react-hook-form";
import { useParams, useLocation, useNavigate } from "react-router-dom";

import Breadcrumb from "Components/Breadcrums";
import FormControl from "Components/FormControl";
import Imagepreview from "Components/ImagePreview";
import Upload from "Components/UploadDesign/upload";
import { showErrorAlert, showWarningAlert, Toast } from "Util/Alerts";

import { config } from "../../../s3config";
import { breadcrumbItems } from "./Constant";
import { exclusiveType, exclusiveInputs } from "./Types";
import { add_Exclusive, update_Exclusive } from "Services/Requests";
import Styles from "Styles/Styles.module.css";

window.Buffer = window.Buffer || require("buffer").Buffer;

function AddExclusive() {
    const navigate = useNavigate();
    const fileTypes = ["JPG", "PNG", "JPEG"];
    const { type } = useParams();
    const location = useLocation();
    const [loading, setLoading] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState<boolean>(false);

    const [exclusiveImg, setexclusiveImg] = useState("");
    const [ErrorMsg, setErrorMsg] = useState<null | string>(null);

    const {
        register,
        handleSubmit,
        formState: { errors },
        setValue,
        resetField,
        reset,
        watch,
        setError,
    } = useForm<exclusiveInputs>();

    const handleChange = (files: any) => {
        setErrorMsg("");
        let maxSize = 2 * 1024 * 1024;
        if (files.size > maxSize) {
            alert("File size cannot be greater than 2 MB");
            return;
        }

        const timestamp = Date.now();
        const fileName = `${timestamp}`;
        const s3 = new ReactS3Client({
            ...config,
            dirName: "exclusiveImages",
        });
        setLoading(true);
        s3.uploadFile(files, fileName)
            .then((res: any) => {
                setValue("imageUrl", `${String(res.key).split("/")[1]}`);
                setexclusiveImg(res.location);
                setLoading(false);
            })
            .catch((err: any) => {
                alert(err);
                setLoading(false);
            });
    };

    const onSubmit: SubmitHandler<exclusiveInputs> = async (data) => {
        if (!exclusiveImg) {
            setErrorMsg("Please Upload File");
            return;
        }
        try {
            setLoading(true);
            let response;
            if (type === "edit") {
                response = await update_Exclusive(
                    location.state?.exclusiveId,
                    data
                );
            } else {
                response = await add_Exclusive(data);
            }
            if (response?.data?.status === 1) {
                Toast(response?.data?.Message, "success");
                navigate(-1);
            } else {
                showWarningAlert(response?.data?.Message);
            }
        } catch (err: any) {
            showErrorAlert(
                err?.response?.data?.Message ||
                    err?.response?.data?.message ||
                    "Something went wrong, try again later"
            );
        } finally {
            setLoading(false);
        }
    };

    const watchData = watch();

    useEffect(() => {
        if (type === "edit") {
            let formData = location.state;
            formData = {
                ...formData,

                imageUrl: String(formData.imageUrl).split("/")[
                    String(formData.imageUrl).split("/").length - 1
                ],
            };
            reset({ ...formData });
            setexclusiveImg(location.state?.imageUrl);
        }
    }, [type, location.state, reset]);

    return (
        <div className={Styles["Add_form_wrapper"]}>
            <Imagepreview
                handleCancel={() => setIsModalVisible(false)}
                selectedImage={exclusiveImg}
                isModalVisible={isModalVisible}
                title="exclusive"
            />
            <h3>
                <span style={{ textTransform: "capitalize" }}>{type}</span>{" "}
                Exclusive
            </h3>
            <Breadcrumb items={breadcrumbItems} type={type} />
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className={Styles["form"]}>
                    <h4>Exclusive</h4>

                    <div className={Styles["form_control"]}>
                        <label htmlFor="Photo">Photo</label>
                        <FileUploader
                            handleChange={handleChange}
                            name="file"
                            types={fileTypes}
                            children={Upload}
                        />
                        {exclusiveImg && (
                            <div className={Styles["remove_upload"]}>
                                <div onClick={() => setIsModalVisible(true)}>
                                    <img src={exclusiveImg} alt="exclusive" />
                                    <p>{watchData.imageUrl}</p>
                                </div>
                                <button
                                    onClick={() => {
                                        resetField("imageUrl");
                                        setexclusiveImg("");
                                    }}>
                                    <MdDelete />
                                </button>
                            </div>
                        )}
                        {type == "edit" && (
                            <FormControl
                                key={"status"}
                                label={"Status"}
                                name={"status"}
                                register={register}
                                errors={errors["status"]}
                                requiredMessage={"this field is required"}
                                type={"select"}
                                options={[
                                    { value: 1, label: "Active" },
                                    { value: 0, label: "Inactive" },
                                ]}
                            />
                        )}
                    </div>
                    {ErrorMsg && (
                        <p className={Styles["Gen-erro_msg"]}>
                            <IoIosWarning /> {ErrorMsg}
                        </p>
                    )}
                </div>

                {loading ? (
                    <Spin size="default" />
                ) : (
                    <button>{type === "edit" ? "Update" : "Add"}</button>
                )}
            </form>
        </div>
    );
}

export default AddExclusive;
